import { Row, Col } from 'react-bootstrap';
import { IManagingWindowsServiceInstance } from '../../api/models';
import { ApiDataWrapper } from '../UIExtentions/ApiDataWrapper';

export const WindowsServiceInstallInfoView = (props: any) => {
    return (
        <>
            <ApiDataWrapper
                objectType="Install Info"
                objectName={props.applicationName}
                isLoading={props.isLoading}
                isDataNotFound={props.isDataNotFound}
                errorMessage={props.errorMessage}
            >
                <ServerWindowsServiceDetails serverApp={props.serverApps}></ServerWindowsServiceDetails>
            </ApiDataWrapper>
        </>
    );
};

export function ServerWindowsServiceDetails(props: any) {
    const serverApp = props.serverApp as IManagingWindowsServiceInstance;
    return (
        <>
            <Row>
                <Col sm={2}>Run as user:</Col>
                <Col>{serverApp.runAsUser}</Col>
            </Row>
            <Row>
                <Col sm={2}>Bin path:</Col>
                <Col>
                    <span style={{ lineBreak: 'anywhere' }}>{serverApp.binPath}</span>
                </Col>
            </Row>
            <Row>
                <Col sm={2}>Process id:</Col>
                <Col>{serverApp.processId}</Col>
            </Row>
        </>
    );
}
